export function PlayOverlay(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_2441_80359)">
        <rect
          width="40"
          height="40"
          rx="20"
          fill="currentColor"
          fillOpacity="0.15"
        />
        <rect
          width="15"
          height="16.665"
          transform="translate(13.75 11.5278)"
          fill="url(#pattern0_2441_80359)"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2441_80359"
          x="-20"
          y="-20"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2441_80359"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2441_80359"
            result="shape"
          />
        </filter>
        <pattern
          id="pattern0_2441_80359"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_2441_80359"
            transform="matrix(0.0052356 0 0 0.00471251 0 -0.00188265)"
          />
        </pattern>
        <image
          id="image0_2441_80359"
          width="191"
          height="213"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
